import { type } from './type.js';

/**
 * @description
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @example
 * ``` ts
 * isString('');
 * // => true
 * isString(1);
 * // => false
 * isString({toString() {return '';}})
 * // => false
 * ```
 *
 * @param value The value to check.
 * @returns Returns true if value is a string, else false.
 *
 * @docsCategory preference/lang
 * @codeFilter is-string
 */
export const isString = (value): value is string => {
  return type(value) === 'string';
};
